import React from "react";
import { Col, FormGroup, Row } from "reactstrap";
import { firebaseConnect, isLoaded } from "react-redux-firebase";
import { connect } from "react-redux";
import withStyles from "isomorphic-style-loader/withStyles";
import s from "./styles.scss";
import { serviceCaller, ServiceCallerProps } from "../../composition";
import isEqual from "lodash.isequal";
import isEmpty from "lodash.isempty";

import get from "lodash.get";
import AsyncSelect from "react-select/async";
import { brandSelectTheme } from "../../../toolkit/baseSelect/theme";
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import { IPost, PostType } from "../../../types/services/IPost";
import ISegment from "../../../types/services/ISegment";
import { searchDonors, searchDonorsByIdsExtended } from "../../../utils/fetch";
import { isCurrentUserCollaborator } from "../../../utils/roleCheck";
import { nodeForPostType, getActiveMedium } from "../../../utils/helpers";
import { withRouter } from "../../../utils/withRouter";

interface Props extends ServiceCallerProps {
  currentPost?: {
    post: IPost;
    type: PostType;
  };
  firebase: firebase.app.App;
  firebaseSegments: { [s: string]: ISegment };
  canEditPublishing: boolean;
  busyLoading: boolean;
  thanksDonorSegments?: Array<{ label: string; value: string }>;
  isVisible: boolean;

  updateSegments: (
    segmentsLits: Array<{ label: string; value: string }>,
    excluded: Array<{ label: string; value: string }>
  ) => void;
  updateRecipientsLoading?: (loading: boolean) => void;
}

interface State {
  segmentsList: Array<{ label: string; value: string }>;
  defaultSegmentOptions: Array<{ label: string; value: string }>;
  segmentsOptions: Array<{ label: string; value: string }>;
  excludeSegmentsList: Array<{ label: string; value: string }>;
  excludeSegmentsOptions: Array<{ label: string; value: string }>;
  time: number;
}

class SegmentsSection extends React.PureComponent<Props, State> {
  static defaultProps = {
    isVisible: true,
  };

  constructor(props: Props) {
    super(props);
    this.state = {
      segmentsList: [],
      defaultSegmentOptions: [],
      segmentsOptions: [],
      excludeSegmentsList: [],
      excludeSegmentsOptions: [],
      time: 0,
    };
  }

  applyThanksDonorSegments = () => {
    if (!this.props.thanksDonorSegments?.length) {
      return;
    }
    this.setState(
      {
        segmentsList: this.props.thanksDonorSegments,
      },
      () =>
        this.props.updateSegments(
          this.state.segmentsList,
          this.state.excludeSegmentsList
        )
    );
  };

  componentDidMount() {
    if (this.props.currentPost && this.props.currentPost.post) {
      this.fillPostData();
    }
    this.applyThanksDonorSegments();
  }

  componentDidUpdate(prevProps: Props) {
    const { firebaseSegments, currentPost } = this.props;

    if (
      currentPost?.post &&
      !prevProps.currentPost?.post &&
      this.props.config?.searchServiceUrl
    ) {
      this.fillPostData();
    }

    if (
      !isEmpty(firebaseSegments) &&
      (!isEqual(firebaseSegments, prevProps.firebaseSegments) ||
        this.state.defaultSegmentOptions.length == 0)
    ) {
      const segments = Object.keys(this.props.firebaseSegments)
        .filter(
          segmentId => this.props.firebaseSegments[segmentId]?.name != null
        )
        .map(segmentId => ({
          label: this.props.firebaseSegments[segmentId].name,
          value: "S" + segmentId,
        }))
        .sort((s1, s2) => {
          if (s1.label.toUpperCase() > s2.label.toUpperCase()) {
            return 1;
          } else if (s1.label.toUpperCase() < s2.label.toUpperCase()) {
            return -1;
          }
          return 0;
        });

      this.setState({
        defaultSegmentOptions: segments,
        excludeSegmentsOptions: segments,
        segmentsOptions: segments,
      });
      this.relabelPendingSegments();
    }

    if (
      !isEqual(this.props.thanksDonorSegments, prevProps.thanksDonorSegments) &&
      this.props.thanksDonorSegments
    ) {
      this.applyThanksDonorSegments();
    }
  }

  updateSegmentsList = selected => {
    const removed = this.state.defaultSegmentOptions.filter(
      segment =>
        !this.listIncludesElement(segment.value, selected) &&
        !this.listIncludesElement(segment.value, this.state.excludeSegmentsList)
    );

    this.setState(
      {
        segmentsList: selected ? selected : [],
        excludeSegmentsOptions: removed ? removed : [],
        segmentsOptions: removed ? removed : [],
      },
      () =>
        this.props.updateSegments(
          this.state.segmentsList,
          this.state.excludeSegmentsList
        )
    );
  };

  updateExcludeSegmentsList = selected => {
    const removed = this.state.defaultSegmentOptions.filter(
      segment =>
        !this.listIncludesElement(segment.value, selected) &&
        !this.listIncludesElement(segment.value, this.state.segmentsList)
    );

    this.setState(
      {
        excludeSegmentsList: selected ? selected : [],
        segmentsOptions: removed ? removed : [],
        excludeSegmentsOptions: removed ? removed : [],
      },
      () =>
        this.props.updateSegments(
          this.state.segmentsList,
          this.state.excludeSegmentsList
        )
    );
  };

  searchSegments = inputValue => {
    if (!this.props.config) {
      return Promise.resolve([]);
    }
    return searchDonors(
      this.props.config.searchServiceUrl,
      this.props.currentCharity.id,
      100,
      0,
      inputValue,
      this.props.serviceAccessToken,
      "FIRST_NAME",
      true,
      undefined,
      null,
      null,
      false,
      true
    ).then(response => {
      if (response.time > this.state.time) {
        this.setState({
          time: response.time,
        });

        let segments = this.props.firebaseSegments
          ? Object.keys(this.props.firebaseSegments)
              .filter(segmentId => {
                const name = this.props.firebaseSegments[segmentId]?.name;
                return (
                  name != null &&
                  name.toLowerCase().includes(inputValue.toLowerCase())
                );
              })
              .map(segmentId => ({
                id: segmentId,
                name: this.props.firebaseSegments[segmentId].isKeyword
                  ? `Keyword - ${this.props.firebaseSegments[segmentId].name}`
                  : this.props.firebaseSegments[segmentId].name,
                isDonor: false,
              }))
          : [];

        let donors = response.result
          .map(donor => ({
            id: donor.id,
            name:
              (donor.name ? donor.name : donor.company) +
              " - " +
              getActiveMedium(donor),
            isDonor: true,
          }))
          .concat(segments)
          .sort((n1, n2) => {
            if (n1.name < n2.name) return -1;
            if (n1.name > n2.name) return 1;
            return 0;
          })
          .map(value => ({
            label: value.name,
            value: (value.isDonor ? "D" : "S") + value.id,
          }));
        const finalDonors = donors.filter(donor => {
          return (
            !this.listIncludesElement(donor.value, this.state.segmentsList) &&
            !this.listIncludesElement(
              donor.value,
              this.state.excludeSegmentsList
            )
          );
        });
        return finalDonors;
      } else {
        throw new Error("Outdated response");
      }
    });
  };

  listIncludesElement = (donorId, list): Boolean => {
    let isIncluded = false;
    list?.forEach(elem => {
      if (donorId == elem.value) {
        isIncluded = true;
        return;
      }
    });
    return isIncluded;
  };

  noResultMessage = value =>
    value.inputValue.length == 0 ? "Type to Search" : "No Results";

  private fillRequestId = 0;

  componentWillUnmount() {
    this.fillRequestId++;
    this.props.updateRecipientsLoading?.(false);
  }

  donorLabel = (donor): string =>
    (donor.name ? donor.name : donor.company) + " - " + getActiveMedium(donor);

  placeholderDonors = (ids: Array<string>) =>
    ids.map(id => ({ label: "Loading contact…", value: "D" + id }));

  relabelDonors = (
    list: Array<{ label: string; value: string }>,
    labels: Map<string, string>
  ) =>
    list.map(item =>
      item.value.charAt(0) === "D" && item.label === "Loading contact…"
        ? {
            ...item,
            label: labels.get(item.value) ?? "Contact unavailable",
          }
        : item
    );

  relabelPendingSegments = () => {
    const resolve = (list: Array<{ label: string; value: string }>) =>
      list.map(item =>
        item.label === "Loading segment…"
          ? {
              ...item,
              label:
                this.props.firebaseSegments[item.value.slice(1)]?.name ??
                "Segment unavailable",
            }
          : item
      );
    const pending = item => item.label === "Loading segment…";
    if (
      !this.state.segmentsList.some(pending) &&
      !this.state.excludeSegmentsList.some(pending)
    ) {
      return;
    }
    this.setState(
      state => ({
        segmentsList: resolve(state.segmentsList),
        excludeSegmentsList: resolve(state.excludeSegmentsList),
      }),
      () =>
        this.props.updateSegments(
          this.state.segmentsList,
          this.state.excludeSegmentsList
        )
    );
  };

  fillPostData = () => {
    const post = this.props.currentPost?.post;
    const searchUrl = this.props.config?.searchServiceUrl;
    if (!post || !searchUrl) {
      return;
    }

    const requestId = ++this.fillRequestId;
    const donorIds = this.loadDonorsID(post.donors);
    const excludedDonorIds = this.loadDonorsID(post.excludeDonors);

    const segmentsList = this.loadSegments(
      post.segments,
      this.placeholderDonors(donorIds)
    );
    const excludeSegmentsList = this.loadSegments(
      post.excludeSegments,
      this.placeholderDonors(excludedDonorIds)
    );

    let excludedListOptions = this.state.defaultSegmentOptions;
    segmentsList.concat(excludeSegmentsList).forEach(elem => {
      excludedListOptions = excludedListOptions.filter(
        segment => segment.value != elem.value
      );
    });

    this.setState(
      {
        segmentsList,
        excludeSegmentsList,
        segmentsOptions: excludedListOptions,
        excludeSegmentsOptions: excludedListOptions,
      },
      () =>
        this.props.updateSegments(
          this.state.segmentsList,
          this.state.excludeSegmentsList
        )
    );

    if (donorIds.length === 0 && excludedDonorIds.length === 0) {
      return;
    }

    this.props.updateRecipientsLoading?.(true);
    const lookup = (ids: Array<string>) =>
      ids.length === 0
        ? Promise.resolve([])
        : searchDonorsByIdsExtended(
            searchUrl,
            this.props.currentCharity.id,
            ids,
            this.props.serviceAccessToken
          );

    Promise.all([lookup(donorIds), lookup(excludedDonorIds)])
      .then(([included, excluded]) => {
        const labels = new Map<string, string>();
        included.concat(excluded).forEach(donor => {
          if (donor) {
            labels.set("D" + donor.id, this.donorLabel(donor));
          }
        });
        return labels;
      })
      .catch(() => new Map<string, string>())
      .then(labels => {
        if (requestId !== this.fillRequestId) {
          return;
        }
        this.setState(
          state => ({
            segmentsList: this.relabelDonors(state.segmentsList, labels),
            excludeSegmentsList: this.relabelDonors(
              state.excludeSegmentsList,
              labels
            ),
          }),
          () => {
            this.props.updateSegments(
              this.state.segmentsList,
              this.state.excludeSegmentsList
            );
            this.props.updateRecipientsLoading?.(false);
          }
        );
      });
  };

  loadDonorsID = (
    donorList?: { [key: string]: boolean } | null
  ): Array<string> => {
    if (!donorList) {
      return [];
    }
    let ids = [];
    for (let key in donorList) {
      ids.push(key);
    }
    return ids;
  };

  loadSegments = (
    segmentList: { [key: string]: boolean } | null | undefined,
    newList: Array<{
      label: string;
      value: string;
    }>
  ): Array<{ label: string; value: string }> => {
    if (!segmentList) {
      return newList;
    }
    const segmentsLoaded = !isEmpty(this.props.firebaseSegments);
    for (let key in segmentList) {
      const segment = this.props.firebaseSegments[key];
      if (segment?.name != null) {
        newList.push({
          label: segment.name,
          value: "S" + key,
        });
      } else if (!segmentsLoaded) {
        newList.push({ label: "Loading segment…", value: "S" + key });
      }
    }

    return newList;
  };

  render() {
    if (!this.props.isVisible) return null;
    const { canEditPublishing, busyLoading } = this.props;
    return (
      <Row>
        <Col md={12} sm={12} lg={12} xl={{ size: 8, offset: 2 }}>
          <FormGroup>
            <label className={s.titleLabel} htmlFor="segments">
              Add Segments and/or Contacts
            </label>
            <AsyncSelect
              id={"segmentationSelect"}
              isMulti
              isDisabled={
                !canEditPublishing ||
                busyLoading ||
                !isCurrentUserCollaborator(this.props.currentCharity)
              }
              loadOptions={this.searchSegments}
              value={this.state.segmentsList}
              placeholder="Entire File is default"
              defaultOptions={this.state.segmentsOptions}
              onChange={this.updateSegmentsList}
              noOptionsMessage={this.noResultMessage}
              className={s.select}
              classNamePrefix={"select"}
              theme={brandSelectTheme}
            />
          </FormGroup>
        </Col>

        <Col md={12} sm={12} lg={12} xl={{ size: 8, offset: 2 }}>
          <FormGroup>
            <label className={s.titleLabel} htmlFor="excludesegments">
              Exclude Segments and/or Contacts
            </label>
            <AsyncSelect
              id={"excludeSegmentationSelect"}
              isMulti
              isDisabled={
                !canEditPublishing ||
                busyLoading ||
                !isCurrentUserCollaborator(this.props.currentCharity)
              }
              loadOptions={this.searchSegments}
              value={this.state.excludeSegmentsList}
              placeholder="No Exclusions"
              defaultOptions={this.state.excludeSegmentsOptions}
              onChange={this.updateExcludeSegmentsList}
              noOptionsMessage={this.noResultMessage}
              className={s.select}
              classNamePrefix={"select"}
              theme={brandSelectTheme}
            />
          </FormGroup>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = (state, props) => {
  const { firebase, user } = state;
  const previousPost =
    props.params.postId &&
    isLoaded(firebase.data[user.currentCharity.id]) &&
    isLoaded(
      firebase.data[user.currentCharity.id][
        nodeForPostType(props.params.postType)
      ]
    ) &&
    isLoaded(
      firebase.data[user.currentCharity.id][
        nodeForPostType(props.params.postType)
      ][props.params.postId]
    )
      ? get(
          firebase,
          `data.${user.currentCharity.id}.${nodeForPostType(
            props.params.postType
          )}.${props.params.postId}`
        )
      : null;

  return {
    currentPost: !previousPost
      ? null
      : {
          post: previousPost,
          type: props.params.postType,
        },
    firebaseSegments: get(
      firebase,
      `data.${user.currentCharity.id}.segments`,
      {}
    ),
  };
};

export default serviceCaller(
  connect(mapStateToProps)(
    firebaseConnect((props, store) => {
      const result =
        store.getState().user.currentCharity.id !== ""
          ? [
              `${store.getState().user.currentCharity.id}/segments`,
              `${store.getState().user.currentCharity.id}/config/hasApps`,
            ]
          : [];
      if (
        props.params.postType &&
        props.params.postId &&
        store.getState().user.currentCharity.id !== ""
      ) {
        const node = nodeForPostType(props.params.postType);
        result.push(
          `${store.getState().user.currentCharity.id}/${node}/${
            props.params.postId
          }`
        );
      }
      return result;
    })(withStyles(s)(withRouter(SegmentsSection)))
  )
);
